import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classes from './registrationSuccess.module.css';
import Header from '../../components/standartComponents/header';

const RegistrationSuccess = ({ authUser }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <>
            <Header authUser={authUser} />
            <div className={classes.wrap}>
                {/* HERO */}
                <div className={classes.hero}>
                    <div className={classes.heroIcon}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                    </div>
                    <h1>
                        {authUser?.displayName
                            ? <>{t("Congratulations,")} {authUser.displayName}! {t("Your account has been created")}</>
                            : t("Congratulations! Your account has been created")
                        }
                    </h1>
                    <p>{t("Your progress, dictionary, and learning plans will now be saved in your account.")}</p>
                    <div className={classes.choose}>{t("Choose how you would like to start learning.")}</div>
                </div>

                <div className={classes.secLabel}>{t("How would you like to learn?")}</div>

                {/* CARDS */}
                <div className={classes.cards}>
                    {/* Primary: Create Plan */}
                    <div className={`${classes.card} ${classes.cardPrimary}`} onClick={() => navigate('/survey')}>
                        <div className={classes.cardBadge}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z"/></svg>
                            {t("Recommended")}
                        </div>
                        <div className={`${classes.cardIcon} ${classes.ci1}`}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
                        </div>
                        <h3>{t("Get a personal plan")}</h3>
                        <div className={classes.desc}>{t("You can start with a structured plan or choose videos yourself.")}</div>
                        <div className={classes.cardBullets}>
                            <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Structured lesson path")}</div>
                            <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Video → Words → Quiz → Speaking</div>
                            <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Progress and results are saved")}</div>
                        </div>
                        <button className={`${classes.cardCta} ${classes.ctaP}`}>
                            {t("Create my plan")}
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                        </button>
                    </div>

                    {/* Secondary: Self Study */}
                    <div className={classes.card} onClick={() => navigate('/catalog')}>
                        <div className={`${classes.cardIcon} ${classes.ci2}`}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
                        </div>
                        <h3>{t("Learn without a plan")}</h3>
                        <div className={classes.desc}>{t("Browse videos and choose topics to practice. Learn at a time that suits you.")}</div>
                        <div className={classes.cardBullets}>
                            <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("Any topic")}</div>
                            <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("No fixed order")}</div>
                            <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>{t("You can switch to a plan later")}</div>
                        </div>
                        <button className={`${classes.cardCta} ${classes.ctaS}`}>
                            {t("Browse videos")}
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                        </button>
                    </div>
                </div>

                {/* REASSURANCE */}
                <div className={classes.reassure}>
                    <div className={classes.reassureTitle}>{t("You can change the mode later.")}</div>
                    <div className={classes.reassureItems}>
                        <div className={classes.ri}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                            {t("If you start without a plan, you can create a personal course at any time.")}
                        </div>
                        <div className={classes.ri}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                            {t("If you create a plan, you can still watch videos independently.")}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegistrationSuccess;